exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.nut-tabbar{\n    height: 50px!important;\n    border-bottom:none!important;\n}\n.tabbar-nav-word{\n    display: block;\n}\n.tabbar-nav .icon-box .icon{\n    width: 20px;height: 20px;\n}\n", ""]);

